export default "__VITE_ASSET__CMqf4FH8__"